import React, { useCallback, useEffect, useState } from "react";
import {useDispatch, useSelector } from "react-redux";
import "./VirtualClassroom.scss";
import CommonTabs from "../../../common/Pilots/CommonTabs/CommonTabs";
import { VIRTUAL_CLASS_ROOM_OR_ENGINES_API_PATH } from "../../../../helper/APIPaths";
import { useTranslation } from "react-i18next";
import { COMMON_MESSAGES, VIRTUAL_CLASSROOMS_AND_ENGINES_API_PARAMS } from "../../../../helper/constants";
import CircularLoader from "../../../common/Loader/CircularLoader";
import { isPilot } from "../../../../helper/commonFunctions";
import { setMenuSelection } from "../../../../storage/reducers/menuSelectorReducer";

const VirtualClassRoomDetailList = () => {
      const { t } = useTranslation();
      const dispatch = useDispatch(); 
      const { userInformation } = useSelector((state: any) => state?.userInformation);
      const { subCategoryNameVirtualClassrooms, itemName } = useSelector((state: any) => state?.virtualClassRoomsOrEngines);
      const [tabTitles, setTabTitles] = useState<Array<object>>([]);
      const [loading, setLoading] = useState(true);
      const [error, setError] = useState(false);
      const { itemCategory, pilot_category_name_VC, weather_radar } = VIRTUAL_CLASSROOMS_AND_ENGINES_API_PARAMS;

      useEffect(() => {
        if (tabTitles.length === 0) {
          fetchVirtualClassroomElements();
        }
        if(subCategoryNameVirtualClassrooms.toLowerCase() === weather_radar){
          dispatch(setMenuSelection({currentMenuTitle: itemName}));
        }else{
          dispatch(setMenuSelection({currentMenuTitle: subCategoryNameVirtualClassrooms}));
        }
      }, [tabTitles.length, subCategoryNameVirtualClassrooms]);

       const fetchVirtualClassroomElements = useCallback(async () => {      
          
          const payload = {
            pilot_category_name: pilot_category_name_VC,
            pilot_subcategory_name: subCategoryNameVirtualClassrooms || null,
            pilot_item_name: itemName,
            type:itemCategory,
            role: isPilot(userInformation?.jobTitle || ""),
          };
      
          try {
              const response = await fetch(VIRTUAL_CLASS_ROOM_OR_ENGINES_API_PATH, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(payload),
              });
              const res = await response.json();
              const data = res?.data?.preflightData;
              if (data) {
                setTabTitles(data);
                setLoading(false);
                setError(false); 
              }
          } catch (ierror) {
            console.error(
              "Error while fetching virtual classrooms data details",
              ierror
            );
            setLoading(false);
            setError(true);
          }
        }, []);

  return (
    <div  className='virtualClassroomContainer'>
        {loading && <CircularLoader />}
        {tabTitles.length > 0 && <CommonTabs tabs={tabTitles} category={pilot_category_name_VC} />}
        {(!loading && tabTitles.length === 0) && (
          <div className='error'>{t(COMMON_MESSAGES.NO_RECORDS_FOUND)}</div>
        )}
        {error  && (
          <div className='error'>{t(COMMON_MESSAGES.NO_DATA_AVAILABLE)}</div>
        )}
    </div>
  );
};

export default VirtualClassRoomDetailList;